import classNames from "classnames"
import type { AnchorHTMLAttributes } from "react"
import React from "react"

import SafeLink from "@/components/Generic/SafeLink/SafeLink"

type ChipButtonProps = {
  onClick?: () => void
  children: React.ReactNode
  className?: string
}

const ChipLink = ({ href, children, className, onClick }: ChipButtonProps & { href: string }) => (
  <SafeLink href={href} className={classNames(styles.chip, className)} onClick={onClick}>
    {children}
  </SafeLink>
)

const ChipButton = ({ onClick, children, className }: ChipButtonProps) => (
  <button onClick={onClick} className={classNames(styles.chip, className)}>
    {children}
  </button>
)

export type PoiChipNavItemProps = {
  label: string
  onClick?: () => void
  className?: string
  icon?: React.ComponentType<{ className?: string }>
} & Pick<AnchorHTMLAttributes<HTMLAnchorElement>, "href">

export const PoiChipNavItem = ({ label, onClick, className, href, icon: Icon }: PoiChipNavItemProps) => {
  const ChipContent = (
    <>
      {Icon && <Icon className="size-4" />}
      <span>{label}</span>
    </>
  )

  if (href) {
    return (
      <ChipLink href={href} onClick={onClick} className={classNames(styles.container, className)}>
        {ChipContent}
      </ChipLink>
    )
  }

  return (
    <ChipButton onClick={onClick} className={classNames(styles.container, className)}>
      {ChipContent}
    </ChipButton>
  )
}

const styles = {
  container: "flex items-center gap-1.5",
  chip: "rounded-full px-4 py-2 text-sm font-medium transition-colors whitespace-nowrap bg-primary-200 text-black",
}
